<template lang="html">
	<transition name="fade">
		<footer id="main-footer" v-if="loaded">
			<!-- <span @click.prevent="toggleMode" class="switcher"></span> -->
			<nav>
				<a href="https://directories.onepercentfortheplanet.org/profile/1percent-for-the-planet-france" target="_blank">
					<span class="logo-planet"></span>
				</a>
				<router-link 
				:to="{ 
					path: getPath('Legal'), 
					meta: { lang: currentLang 
					} }">
				{{ $t('legaNotice') }}</router-link>
				<!-- <router-link :to="{ name: 'cgv' }">CGV</router-link> -->
			</nav>
			<!-- <span @click.prevent="toggleMode" class="switcher reverse"></span> -->
		</footer>
	</transition>
</template>

<script>

import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	name: 'footerSite',
	mixins: [loaderHandler],
	props: ['site', 'currentLang'],
	methods:{
		getPath(routeName){
			let matchingRt = this.$router.options.routes.find(rt => rt.name === routeName);
			return matchingRt.meta[this.currentLang+'Path']
		}
		// toggleMode(){
		// 	let body = document.getElementsByTagName('body')[0];
		// 	let errorClass = body.classList.contains('error') ? true : false;
		// 	body.classList = body.classList.contains('darkMode') ? "whiteMode" : "darkMode";
		// 	if(errorClass) body.classList.add('error');
		// }
	},
	watch:{
		$route($route){
			if(!$route.hash){
				this.loaded = false;
				this.displayComponent(2000);
			}
			
		}
	}, 
	mounted(){
		this.displayComponent(2000);
	}
}
</script>

<style lang="scss">
#main-footer{
	padding: 1.5rem;
	@media screen and (min-width:768px){
		padding: 2.3rem 2.9rem;
	}
	nav{
		@include flexbox();
		@include align-items(center);
		@include justify-content(center);
		width:100%;
		a{
			font-family: 'surtSemiBold_extended', Helvetica, Arial, sans-serif;
			color:var(--discret);
			text-transform: uppercase;
			font-size:.7333rem;
			font-weight:bold;
			letter-spacing: 0.785714px;
			display:block;
			padding: 0 1.8666666667rem;
			&:hover{
				color: rgba(20, 20, 20, 1)
			}
		}
	}
	.logo-planet{
		width:45px;
		height:60px;
		display: inline-block;
		cursor:pointer;
		background:url('../assets/img/planet-logo.svg') no-repeat center;
		opacity: 1;
		transition: opacity .3s ease;
		&:hover{
			opacity: .5;
		}
	}
	.switcher{
		width:35px;
		height:35px;
		display: inline-block;
		cursor:pointer;
		background:url('../assets/img/logo_DT.svg') no-repeat center;
		&.reverse{
			@include transform(rotate(180deg));
		}
	}
	
}

</style>
